// ** React Imports
import { useContext } from "react";

// ** Redux & Store & Actions
import { useDispatch, useSelector } from "react-redux";
import { getHomeGallery } from "store/modules/main-pages/home/get-home-gallery.action";

// ** Custom Components
import Link from "components/layout/Link";
import Block from "components/layout/Block";

// ** Custom Hooks
import useBreakpoint from "hooks/useBreakpoint";

// ** Styled Components
import { StyledHeaderLogo } from "../styles";

// ** Context
import authContext from "contexts/authContext";

// #####################################################

const Logo = ({ isUserFrozen }) => {
	const dispatch = useDispatch();

	const isPhoneSizeM = useBreakpoint("phoneM", "max");

	const isDarkMode = useSelector(
		(state) => state.globalCommon?.darkMode?.isDarkMode
	);

	const isAuth = useContext(authContext);

	const handleHomePageClick = () => {
		dispatch(
			getHomeGallery({
				filters: { mediaType: "any" },
			})
		);
	};

	// #####################################################

	return (
		<Block flex alignCenter>
			{isAuth && isUserFrozen ? (
				<Link to="/userpanel/settings/account">
					<StyledHeaderLogo
						isPhoneSizeM={isPhoneSizeM}
						mode={isDarkMode ? "white" : "blue"}
					/>
				</Link>
			) : (
				<Link to="/" onClick={handleHomePageClick}>
					<StyledHeaderLogo
						isPhoneSizeM={isPhoneSizeM}
						mode={isDarkMode ? "white" : "blue"}
					/>
				</Link>
			)}
		</Block>
	);
};

export default Logo;

// #####################################################
